import { existsFilter } from '@iotv/core-services';
import { Area, Place, isLocatable } from '@iotv/datamodel-core';
import { isIGeofence, isNode, isPosition } from '@iotv/iotv-v3-types';
import { v4 } from 'uuid';
import { getGraphQueryRequestV2 } from '../../../../data/daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
import { getBoundsFromNodeEdgeMapper } from '../../../../GoogleMapV4/mapfns/translation';
import { UserFunctions } from '../../../../redux/actions/AppActionFunctions/AppActions';
import { Severity } from '../../../../types';
import { PropertyAreaPlaceQuery } from '../../QueryPaths/propertyAreaPlace';
const debug = process.env.REACT_APP_DEBUG && false;
const useCoverageShim = true;
/**
 * Coverage shim TEMP, EXPERIMENTAL, to get around `v020` implementation of `Area`
 */
const coverageShim = (vob) => {
    if (isNode(vob) && vob.type === 'Area') {
        const pointsLikeEntry = Object.entries(vob).find(([k, v]) => k !== 'points' && v instanceof Array && v.every((p) => isPosition(p)));
        if (pointsLikeEntry) {
            ;
            vob.points = pointsLikeEntry[1];
            vob.location = pointsLikeEntry[1]?.[0];
        }
    }
    return new Area(vob);
};
/**
 * A full query returning `Place`s and `Area`s based on a `Property`
 * Dispatches only node properties, areas, and places.
 * Returns the full `NodeEdgeMapper` result of the graph query (if needed)
 */
export const populateNetworkCoverageContextFromProperty = async ({ dispatch, properties }) => {
    // TODO: this needs to go deeper than one level
    const { err, data } = await getGraphQueryRequestV2({ query: PropertyAreaPlaceQuery, contextObjects: [...properties] });
    if (err) {
        const msg = `Error in query: ${err.message}`;
        UserFunctions.setUserMessage({ content: msg, id: v4(), label: 'Error', type: 'MessageBar', severity: Severity.error });
    }
    if (data) {
        let areas = data
            .getNodesOfType('Area')
            .filter(existsFilter)
            .filter((a) => isIGeofence(a))
            .filter((area) => area.subType === 'Coverage');
        if (useCoverageShim && typeof coverageShim === 'function') {
            areas = areas.map((area) => coverageShim(area));
        }
        areas = areas.map((area) => new Area(area));
        const places = data
            .getNodesOfType('Place')
            .filter(existsFilter)
            .filter((p) => isLocatable(p))
            .map((place) => new Place(place));
        const bounds = getBoundsFromNodeEdgeMapper({ nodeEdgeMapper: data });
        if (bounds)
            dispatch({ type: 'setBounds', bounds });
        // Load items to nem
        dispatch({ type: 'loadItems', value: { items: [...areas, ...places, ...properties], canaryString: 'populateNetworkCoverageContextFromProperty' } });
        // Load properties, areas and places for coverage
        dispatch({ type: 'setCoverageTargets', properties, areas: areas, places });
        return data;
    }
    else {
        console.log(`WARN: populateNodeEdgeMapperFromProperty no data or err`, { err, data });
    }
};
